import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';

@Injectable()
export class SessionEventService {
  private sessionExpired = new Subject<void>();
  sessionExpired$ = this.sessionExpired.asObservable();

  notifySessionExpired() {
    this.sessionExpired.next();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/session-event.service.ts